import { useEffect, useState } from 'react';
import { Notification } from '../types';
import { mockBackend } from '../services/mockBackend';

type NotificationsPanelProps = {
  userId: string;
  refreshToken: number;
};

const NotificationsPanel = ({ userId, refreshToken }: NotificationsPanelProps) => {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    mockBackend.notifications
      .listNotifications(userId)
      .then(setNotifications)
      .finally(() => setLoading(false));
  }, [refreshToken, userId]);

  if (loading) {
    return (
      <div className="card bg-onyx border-0 shadow-lg">
        <div className="card-body text-white-50">Carregando notificações...</div>
      </div>
    );
  }

  if (notifications.length === 0) {
    return (
      <div className="card bg-onyx border-0 shadow-lg">
        <div className="card-body text-white-50">Você ainda não possui notificações.</div>
      </div>
    );
  }

  return (
    <div className="card bg-onyx border-0 shadow-lg">
      <div className="card-body p-4">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div>
            <h5 className="text-white mb-1">Notificações</h5>
            <p className="text-white-50 mb-0">Tudo o que mudou nos seus eventos, matches e revisões.</p>
          </div>
          <span className="badge bg-brand text-white">{notifications.length}</span>
        </div>

        <div className="notification-list">
          {notifications.map((notification) => (
            <button
              key={notification.id}
              type="button"
              className={`notification-card ${notification.read ? 'read' : ''}`}
              onClick={async () => {
                await mockBackend.notifications.markNotificationRead(notification.id);
                setNotifications((current) =>
                  current.map((item) =>
                    item.id === notification.id ? { ...item, read: true } : item
                  )
                );
              }}
            >
              <div className="d-flex align-items-start justify-content-between gap-3">
                <div>
                  <strong className="d-block text-white">{notification.title}</strong>
                  <span className="text-white-50 small">{notification.body}</span>
                </div>
                {!notification.read && <span className="badge badge-approved">Novo</span>}
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotificationsPanel;
